import {Component, Input, inject} from '@angular/core';
import {FileRepositoryService} from '@common/service/file-repository.service';
import {DataUtils} from '@core/utils/data-util.service';

@Component({
  selector: 'tmw-file-download',
  standalone: true,
  imports: [],
  templateUrl: './file-download.component.html',
})
export class TmwFileDownloadComponent {
  @Input() id: number | undefined;
  fileRepositoryService = inject(FileRepositoryService);
  dataUtils = inject(DataUtils);

  downloadFile(): void {
    if (this.id) {
      this.fileRepositoryService.getFile(this.id).subscribe({
        next: (result) => {
          if (result) {
            // this.dataUtils.openFile(result.fileRepositoryFile, result.fileRepositoryMimeType);
          }
        },
      });
    }
  }
}
